export const getAverageKM = (first: { time: Date; km: number }, second: { time: Date; km: number }) => {
  const timeDiff = second.time.getTime() - first.time.getTime();
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  const kmDiff = second.km - first.km;
  return Math.floor(kmDiff / diffDays);
};

export const getColorByAverageKM = (averageKM: number, alpha: number = 1) => {
  if (averageKM <= 30) {
    return `rgba(135,206,235,${alpha})`;
  }
  if (averageKM >= 30 && averageKM < 50) {
    return `rgba(175,196,131,${alpha})`;
  }
  if (averageKM >= 50 && averageKM < 70) {
    return `rgba(252,162,78,${alpha})`;
  }
  if (averageKM >= 70 && averageKM < 100) {
    return `rgba(224,126,96,${alpha})`;
  }
  return `rgba(191,59,59,${alpha})`;
};
